import React from 'react'
import DistributionContent from './distribution'
import Grid from 'material-ui/Grid'
import Card, { CardContent } from 'material-ui/Card'

const Distribution = () => (
  <Grid container>
    <Grid item lg={8} md={8} sm={12} xs={12} className="shift-top">
      <Card>
        <CardContent>
          <DistributionContent />
        </CardContent>
      </Card>
    </Grid>
  </Grid>
)

export default Distribution



// WEBPACK FOOTER //
// ./src/containers/pages/distribution/index.js